import { render, staticRenderFns } from "./TakibiProductBundleBuilder.vue?vue&type=template&id=63a39908&scoped=true&"
import script from "./TakibiProductBundleBuilder.vue?vue&type=script&lang=js&"
export * from "./TakibiProductBundleBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TakibiProductBundleBuilder.vue?vue&type=style&index=0&id=63a39908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a39908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/owldesign/Sites/snowpeak/website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a39908')) {
      api.createRecord('63a39908', component.options)
    } else {
      api.reload('63a39908', component.options)
    }
    module.hot.accept("./TakibiProductBundleBuilder.vue?vue&type=template&id=63a39908&scoped=true&", function () {
      api.rerender('63a39908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "development/vue-components/TakibiProductBundleBuilder.vue"
export default component.exports